// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FxFwF","selected":"styles_selected__3qDHO"};